import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { getClubs, getResources } from "../actions/actions";

class StudioChoice extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			club: 0,
			resource: 0,
			clubs: [],
			clubDefault: "Getting Clubs...",
			resourceDefault: "Getting Resources...",
			resources: [],
			error: ""
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleResetClick = this.handleResetClick.bind(this);
	}

	componentDidMount() {
		getClubs().then(clubs => {
			this.setState({
				clubs: clubs,
				clubDefault: "Select Club:"
			});
		});
	}

	renderClubOptions() {
		const clubs = this.state.clubs;
		return clubs.map(club => <option key={club.club_id} value={club.club_id}>{club.name}</option>);
	}

	renderResourceOptions() {
		const resources = this.state.resources;
		return resources.map(resource => <option key={resource.resource_id} value={resource.resource_id}>{resource.name}</option>);
	}

	handleResetClick(event) {
		reactLocalStorage.clear();
		this.props.handleNav("login");
		event.preventDefault();
	}

	handleChange(event) {
		const target = event.target;
		const name = target.name;
		const value = target.value;
		this.setState({ [name]: target.value, error: "" });

		if (name === "club") {
			getResources(value).then(resources =>{
				this.setState({
					resources: resources,
					resourceDefault: "Select Resource:"
				});
			});
		}
	}

	handleSubmit(event) {
		if ( this.state.club && this.state.resource ) {
			reactLocalStorage.set("club", this.state.club);
			reactLocalStorage.set("resource", this.state.resource);
			this.props.handleNav("checkin");
		} else {
			this.setState({error: "Club and Resource choice are required."});
		}
		event.preventDefault();
	}

	render() {
		return (
			<div className="welcome-screen">
				<h1>Resource Setup</h1>
				<img src={ process.env.PUBLIC_URL + "/images/icon-ovals.svg" } alt="FFF" className="icon-ovals" />
				<p className="error">{this.state.error}</p>
				<form action="#" onSubmit={this.handleSubmit}>
					<div className="form-field">
						<label htmlFor="club">Club:</label>
						<div className="custom-select">
							<select
								name="club"
								id="club"
								value={this.state.club}
								onChange={this.handleChange}
							>
								<option value="0">{this.state.clubDefault}</option>
								{this.renderClubOptions()}
							</select>
						</div>
					</div>

					<div className="form-field hidden">
						<label htmlFor="resource">Resource:</label>
						<div className="custom-select">
							<select
								name="resource"
								id="resource"
								value={this.state.resource}
								onChange={this.handleChange}
							>
								<option value="">{this.state.resourceDefault}</option>
								{this.renderResourceOptions()}
							</select>
						</div>
					</div>

					<button>Confirm</button>
				</form>
				<a
					href="#noanchor"
					onClick={this.handleResetClick}
					className="icon-gear reset"
				>
					<img
						src={process.env.PUBLIC_URL + "/images/icon-gear.svg"}
						alt="Gear icon"
						className="icon-gear"
					/>
					Reset
				</a>
			</div>
		);
	}
}

export default StudioChoice;



// WEBPACK FOOTER //
// ./src/layouts/StudioChoice.js